"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _color = _interopRequireDefault(require("color"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "inline-block",
    fontSize: "12px"
  },
  label: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "inherit",
    fontWeight: "bold",
    padding: ".125em .75em",
    border: "1px solid",
    backgroundColor: props => {
      return props.backgroundColor || "transparent";
    },
    borderColor: props => {
      return props.borderColor || theme.palette.divider;
    },
    color: props => {
      return props.color || theme.palette.text.secondary;
    },
    borderRadius: "1.25em" //        textTransform: "capitalize",

  }
}));

const getStyles = ({
  color,
  backgroundColor,
  textColor,
  borderColor
}) => {
  if (!color && backgroundColor) {
    color = backgroundColor;
  }

  if (!backgroundColor) {
    return {};
  }

  color = (0, _color.default)(color);

  if (color.isDark()) {
    backgroundColor = color.hex();
    textColor = textColor || 'white';
    borderColor = color.hex();
  } else {
    backgroundColor = color.hex();
    textColor = textColor || 'black';
    borderColor = borderColor || 'rgba(0,0,0,.25)';
  }

  return {
    backgroundColor: backgroundColor,
    color: textColor,
    borderColor: borderColor
  };
};

const ModuleLabel = ({
  className,
  component = "h4",
  label,
  color,
  backgroundColor,
  textColor,
  borderColor,
  children
}) => {
  const styles = getStyles({
    color,
    backgroundColor,
    textColor,
    borderColor
  });
  const classes = useStyles(styles);

  if (!label && children) {
    label = children;
  }

  if (!label) {
    return false;
  }

  return _react.default.createElement("span", {
    className: className || classes.root
  }, _react.default.createElement(_Typography.default, {
    className: classes.label,
    noWrap: true,
    component: component
  }, label));
};

ModuleLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  label: _propTypes.default.string
} : {};
ModuleLabel.defaultProps = {
  label: undefined
};
var _default = ModuleLabel;
exports.default = _default;
module.exports = exports.default;